/* =====================================================================
   HERMES — Duo Shampoo y Aceite de Batana (Homeira Colombia) — brief Id 11

   Chassis CO vigente: gate de animaciones (hm-bat--js), CTAs hero/sticky =
   anchors puros, CTA final = unico boton real con hook classes (regla 5.R),
   CART PRIMER obligatorio (Releasit CO arma la orden desde el carrito),
   kill del floating Releasit (5.B), skin del boton/submit (5.C), deteccion
   desktop triple (regla 2), anti-spy.

   Animaciones NUEVAS de esta landing: oil-fill (clip-path que sube),
   deck-fan (abanico de cartas), drop-ripple (onda concentrica en los pasos),
   curtain-wipe (revelado vertical del retrato), strike-draw (tachado que
   se dibuja en el manifiesto).
   ===================================================================== */
(function () {
  "use strict";

  var root = document.getElementById("hm-bat-root");
  if (!root) return;

  /* Gate JS: los estados iniciales ocultos SOLO aplican con esta clase.
     Si el JS no corre, la landing queda visible completa (regla PASO 54). */
  root.classList.add("hm-bat--js");

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Desktop detection (regla 2 — triple check) ---------------- */
  function isDesktopLike() {
    try {
      var wide = window.matchMedia("(min-width: 1024px)").matches;
      var hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      var noTouch = !("ontouchstart" in window) && navigator.maxTouchPoints === 0;
      return wide || hoverFine || noTouch;
    } catch (e) { return false; }
  }

  var overlay = document.querySelector('.hm-bat-overlay[data-mode="desktop"]');
  if (root.classList.contains("hm-bat--desktop-block") && isDesktopLike() && overlay) {
    overlay.style.display = "flex";
  }

  /* =====================================================================
     CART PRIMER (regla 5.R — obligatorio en toda landing CO con overwrite)
     Releasit CO construye la orden desde el CARRITO. El modo PageFly abre el
     modal pero NO agrega el item: si el carrito esta vacio, create-order
     responde "Empty cart that requires items" y recarga sin crear la orden.
     Producto SIMPLE: una sola variante.
     ===================================================================== */
  var VARIANT_ID = String(root.getAttribute("data-variant-id") || "");
  var ALL_VARIANTS = (root.getAttribute("data-all-variants") || "")
    .split(",").map(function (s) { return s.trim(); }).filter(Boolean);

  var cartPrimed = false;
  var priming = false;
  var lastPrime = 0;
  /* Tras el submit Releasit hace cart/clear.js: apagamos el primer para no
     re-meter el producto en el carrito de un cliente que ya compro. */
  var orderSent = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    });
  }

  function prime(reason, force) {
    if (!window.fetch || !VARIANT_ID) return;
    if (orderSent || priming) return;
    if (!force && cartPrimed && Date.now() - lastPrime < 4000) return;
    priming = true;

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var present = items.some(function (it) {
          return String(it.variant_id) === VARIANT_ID && it.quantity > 0;
        });
        /* limpiar cualquier otra variante de ESTE producto (defensivo) */
        var stale = items.filter(function (it) {
          return ALL_VARIANTS.indexOf(String(it.variant_id)) > -1 && String(it.variant_id) !== VARIANT_ID;
        });
        var chain = Promise.resolve();
        stale.forEach(function (it) {
          chain = chain.then(function () { return postJSON("/cart/change.js", { id: it.key, quantity: 0 }); });
        });
        return chain.then(function () {
          if (present) return null;
          return postJSON("/cart/add.js", { id: parseInt(VARIANT_ID, 10), quantity: 1 });
        });
      })
      .then(function () {
        priming = false;
        cartPrimed = true;
        lastPrime = Date.now();
        try { console.info("[hm-bat] cart primed -> " + VARIANT_ID + " (" + reason + ")"); } catch (e) {}
      })
      .catch(function () { priming = false; });
  }

  /* Trigger 1: click en el area del CTA final (donde vive el boton Releasit) */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest("#hm-bat-cod-slot-final")) prime("cta-final");
  }, true);

  /* Trigger 2: el modal COD de Releasit se abre (cualquier camino) */
  if (window.MutationObserver) {
    var moModal = new MutationObserver(function () {
      var m = document.getElementById("_rsi-cod-form-modal");
      if (m && m.className.indexOf("open") > -1) prime("modal-open");
    });
    moModal.observe(document.body || document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["class"]
    });
  }

  /* Trigger 3 (backstop): click/tap en el submit del modal */
  function submitBackstop(e) {
    var t = e.target;
    if (t && t.closest && t.closest('#_rsi-cod-form-modal [class*="submit"], #_rsi-cod-form-modal button[type="submit"]')) {
      prime("submit");
      setTimeout(function () { orderSent = true; }, 2500);
    }
  }
  document.addEventListener("mousedown", submitBackstop, true);
  document.addEventListener("touchstart", submitBackstop, true);

  /* Mantener la variante en el array de Releasit PageFly mode */
  try {
    var arr = window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS;
    if (arr && typeof arr.length === "number") {
      arr.length = 0;
      arr.push(parseInt(VARIANT_ID, 10));
    }
  } catch (e) {}

  /* =====================================================================
     ANIMACIONES
     ===================================================================== */
  function observe(nodes, cls, opts) {
    if (!nodes.length) return;
    if (!("IntersectionObserver" in window) || prefersReduced) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add(cls); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* boundingClientRect.top < 0 => el elemento quedo ARRIBA del viewport
           (salto de scroll / deep-link). Nunca debe quedarse invisible. */
        if (en.isIntersecting || en.boundingClientRect.top < 0) {
          en.target.classList.add(cls);
          io.unobserve(en.target);
        }
      });
    }, opts || { threshold: 0.16, rootMargin: "0px 0px -50px 0px" });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  /* Red de seguridad: a los 7s nada puede seguir invisible (regla PASO 54) */
  setTimeout(function () {
    root.querySelectorAll("[data-rev],[data-step],[data-fill],[data-curtain],[data-strike],.hm-bat-chip").forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight) n.classList.add("hm-bat--visible");
    });
  }, 7000);

  /* reveal generico */
  observe(root.querySelectorAll("[data-rev]"), "hm-bat--visible");
  /* drop-ripple en los pasos del ritual (NUEVA) */
  observe(root.querySelectorAll("[data-step]"), "hm-bat--visible", { threshold: 0.4 });
  /* oil-fill del heading de origen (NUEVA) */
  observe(root.querySelectorAll("[data-fill]"), "hm-bat--visible", { threshold: 0.7 });
  /* curtain-wipe del retrato (NUEVA) */
  observe(root.querySelectorAll("[data-curtain]"), "hm-bat--visible", { threshold: 0.12 });
  /* strike-draw del manifiesto (NUEVA) */
  observe(root.querySelectorAll("[data-strike]"), "hm-bat--visible", { threshold: 0.35 });

  /* deck-fan: las cartas entran apiladas/rotadas y se enderezan (NUEVA) */
  (function deckFan() {
    var chips = root.querySelectorAll(".hm-bat-chip");
    if (!chips.length) return;
    if (!("IntersectionObserver" in window) || prefersReduced) {
      Array.prototype.forEach.call(chips, function (c) { c.classList.add("hm-bat--visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && en.boundingClientRect.top >= 0) return;
        var idx = Array.prototype.indexOf.call(chips, en.target);
        en.target.style.transitionDelay = (idx * 0.09) + "s";
        en.target.classList.add("hm-bat--visible");
        io.unobserve(en.target);
      });
    }, { threshold: 0.2 });
    Array.prototype.forEach.call(chips, function (c) { io.observe(c); });
  })();

  /* ---------------- Sticky mobile CTA (IO dual: hero + CTA final) ---------------- */
  (function stickyCta() {
    var sticky = document.getElementById("hm-bat-sticky");
    var hero = document.getElementById("hm-bat-hero");
    var finalCta = document.getElementById("hm-bat-final");
    if (!sticky || !hero) return;
    var heroVisible = true;
    var finalVisible = false;
    function sync() {
      if (!heroVisible && !finalVisible) sticky.classList.add("hm-bat--show");
      else sticky.classList.remove("hm-bat--show");
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { heroVisible = e.isIntersecting; sync(); });
    }, { threshold: 0 }).observe(hero);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; sync(); });
      }, { threshold: 0.1 }).observe(finalCta);
    }
  })();

  /* ---------------- Anti-spy layer ---------------- */
  (function antiSpy() {
    if (!root.classList.contains("hm-bat--anti-spy")) return;

    function trigger() {
      if (!overlay) return;
      overlay.style.display = "flex";
      overlay.classList.add("hm-bat-overlay--spy-active");
      root.classList.add("hm-bat--spy-caught");
    }

    document.addEventListener("contextmenu", function (e) { e.preventDefault(); trigger(); });

    document.addEventListener("keydown", function (e) {
      var k = e.key ? e.key.toLowerCase() : "";
      var blocked =
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c"].indexOf(k) > -1) ||
        (e.ctrlKey && ["u", "s", "p"].indexOf(k) > -1);
      if (blocked) { e.preventDefault(); trigger(); }
    });

    root.querySelectorAll("img, video").forEach(function (el) {
      el.setAttribute("draggable", "false");
      el.addEventListener("dragstart", function (e) { e.preventDefault(); });
    });

    var threshold = 160;
    setInterval(function () {
      var widthDelta = window.outerWidth - window.innerWidth;
      var heightDelta = window.outerHeight - window.innerHeight;
      if (widthDelta > threshold || heightDelta > threshold) trigger();
    }, 1500);

    try { console.clear(); } catch (e) {}
  })();

  /* ---------------- QR + WhatsApp self-share (overlay desktop) ---------------- */
  (function overlayShare() {
    var qrBox = document.getElementById("hm-bat-qr");
    var urlBox = document.getElementById("hm-bat-url");
    var waLink = document.getElementById("hm-bat-whatsapp");
    if (!qrBox && !urlBox && !waLink) return;
    var pageUrl = window.location.href;
    if (qrBox) {
      var img = document.createElement("img");
      img.alt = "QR";
      img.src = "https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=" + encodeURIComponent(pageUrl);
      qrBox.appendChild(img);
    }
    if (urlBox) urlBox.textContent = pageUrl.replace(/^https?:\/\//, "");
    if (waLink) waLink.href = "https://wa.me/?text=" + encodeURIComponent("Mira esto: " + pageUrl);
  })();

  /* ---------------- Kill Releasit floating (regla 5.B) ---------------- */
  (function killFloating() {
    var tries = 0;
    var maxTries = 48; /* 24s @ 500ms */
    var iv = setInterval(function () {
      tries++;
      document.querySelectorAll('._rsi-buy-now-button-floating, [class*="_rsi-buy-now"][class*="floating"], [class*="_rsi-floating"], .rsi_floating, #floatingBuyNowButton').forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("opacity", "0", "important");
        el.style.setProperty("pointer-events", "none", "important");
      });
      if (tries >= maxTries) clearInterval(iv);
    }, 500);
  })();

  /* ---------------- Releasit skin (regla 5.C, vence inline styles) ---------------- */
  (function releasitSkin() {
    function skin(el) {
      if (!el) return;
      el.style.setProperty("background", "linear-gradient(135deg, #F0C270, #D99A3C)", "important");
      el.style.setProperty("color", "#21160A", "important");
      el.style.setProperty("border-radius", "999px", "important");
      el.style.setProperty("border", "none", "important");
      el.style.setProperty("font-weight", "700", "important");
      el.style.setProperty("min-height", "56px", "important");
      el.style.setProperty("width", "100%", "important");
    }
    function sweep() {
      document.querySelectorAll('[class*="_rsi"][class*="submit"], [class*="_rsi-cod-form"] button[type="submit"], [class*="_rsi-modal"] button[type="submit"]').forEach(skin);
      /* El boton replace-in-place de Releasit llega con estilos INLINE verdes:
         solo se vence pisandolos por JS (el CSS de la landing pierde). */
      var slot = document.getElementById("hm-bat-cod-slot-final");
      if (slot) {
        slot.querySelectorAll('#_rsi-buy-now-button-overwrite, [id*="_rsi-buy-now-button"]').forEach(function (el) {
          skin(el);
          el.style.setProperty("box-shadow", "0 18px 38px -16px rgba(217,154,60,0.9)", "important");
          el.style.setProperty("font-size", "1rem", "important");
          el.style.setProperty("outline", "none", "important");
          el.querySelectorAll("*").forEach(function (c) {
            c.style.setProperty("color", "#21160A", "important");
            if (c.tagName === "svg" || c.tagName === "SVG") c.style.setProperty("fill", "#21160A", "important");
          });
        });
      }
    }
    sweep();
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(sweep);
      mo.observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      sweep();
      if (tries >= 80) clearInterval(iv); /* ~40s */
    }, 500);
    document.addEventListener("click", function () { setTimeout(sweep, 60); });
  })();
})();
